import React from 'react';

const SignalContactless: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_47_1062)">
        <path d="M3.82848 16.4791C3.62881 16.4791 3.42914 16.3792 3.22947 16.2793C2.83013 15.9797 2.73029 15.2807 3.0298 14.8812C3.62881 13.9823 4.02815 12.9837 4.02815 11.8851C4.02815 10.7865 3.72864 9.78782 3.0298 8.889C2.73029 8.58939 2.83013 7.99017 3.22947 7.69056C3.62881 7.39095 4.32765 7.49082 4.62716 7.8903C5.52568 9.08874 6.02485 10.5868 6.02485 11.985C6.02485 13.483 5.52568 14.8812 4.62716 16.0796C4.42749 16.3792 4.12798 16.4791 3.82848 16.4791Z" />
        <path d="M8.32101 18.876C8.12134 18.876 7.92167 18.876 7.82184 18.6763C7.32266 18.3767 7.22283 17.7775 7.52233 17.2781C8.52068 15.6802 9.01986 13.8826 9.01986 11.985C9.01986 10.0875 8.52068 8.28986 7.52233 6.69195C7.12299 6.1926 7.32266 5.59338 7.722 5.29377C8.22118 4.99417 8.82019 5.09403 9.11969 5.59338C10.3177 7.4909 11.0166 9.68804 11.0166 11.985C11.0166 14.282 10.4176 16.4792 9.11969 18.3767C8.92002 18.6763 8.62052 18.876 8.32101 18.876Z" />
        <path d="M12.7138 21.1731C12.5141 21.1731 12.3144 21.1731 12.2146 21.0732C11.7154 20.7736 11.6156 20.1744 11.9151 19.675C13.3128 17.378 14.0116 14.6815 14.0116 11.9851C14.0116 9.28858 13.3128 6.69197 11.9151 4.39497C11.6156 3.89562 11.7154 3.2964 12.2146 2.9968C12.7138 2.69719 13.3128 2.89693 13.6123 3.2964C15.2096 5.89301 16.0083 8.8891 16.0083 11.9851C16.0083 15.081 15.2096 18.0771 13.6123 20.6737C13.4126 20.9733 13.0133 21.1731 12.7138 21.1731Z" />
        <path d="M17.2064 23.47C17.0067 23.47 16.9068 23.47 16.7072 23.3701C16.208 23.0705 16.1082 22.4713 16.3078 21.972C18.1049 18.9759 19.0034 15.4804 19.0034 11.985C19.0034 8.48957 18.1049 4.99414 16.3078 1.99805C16.0083 1.4987 16.208 0.899485 16.7072 0.599877C17.2064 0.300268 17.8054 0.500007 18.1049 0.999355C20.0017 4.29505 21.0001 8.09009 21.0001 11.985C21.0001 15.78 20.0017 19.5751 18.1049 22.9707C17.8054 23.2703 17.5059 23.47 17.2064 23.47Z" />
      </g>
      <defs>
        <clipPath id="clip0_47_1062">
          <rect
            width="18.17"
            height="22.97"
            fill="white"
            transform="translate(2.83008 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SignalContactless;
